import { BaseTable, TableHeader } from "components";

export function Journal() {
  return (
    <BaseTable>
      <TableHeader>
        <tr>
          <th>DATE</th>
          <th></th>
          <th>ACCOUNT</th>
          <th>DEBET</th>
          <th>CREDIT</th>
        </tr>
      </TableHeader>

      <tbody>
        <tr>
          <td colSpan={5} />
        </tr>
      </tbody>
    </BaseTable>
  )
}